import { useCallback } from "react";
import { useTranslation } from "react-i18next";

/**
 * Labels the recorder chip during a prep gap ("Recording in Ns") so it reads
 * differently from the bare "Ns" recording-limit countdown.
 */
export const usePrepTimerLabel = () => {
	const { t } = useTranslation();
	return useCallback(
		(seconds: number) => t("session.prepBanner.recordingIn", { seconds }),
		[t],
	);
};
